import {
  GET_PICKLIST_DOWNLOAD_FAILURE,
  GET_PICKLIST_DOWNLOAD_REQUEST,
  GET_PICKLIST_DOWNLOAD_SUCCESS,
  GET_PICKLIST_REPORT_FAILURE,
  GET_PICKLIST_REPORT_REQUEST,
  GET_PICKLIST_REPORT_SUCCESS,
} from "./picklistTrackingReportTypes";

const initialStateForTransactionReport = {
  loading: false,
  trnReport: [],
  error: "",
};

const getPicklistTrackingReportReducer = (
  state = initialStateForTransactionReport,
  action
) => {
  switch (action.type) {
    case GET_PICKLIST_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PICKLIST_REPORT_SUCCESS:
      return {
        loading: false,
        trnReport: action.payload,
        error: "",
      };
    case GET_PICKLIST_REPORT_FAILURE:
      return {
        loading: false,
        trnReport: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForDownloadGrnReport = {
  loading: false,
  consumptionReport: [],
  error: null,
};

const downloadPicklistTrackingReportReducer = (
  state = initialStateForDownloadGrnReport, 
  action
) => {
  switch (action.type) {
    case GET_PICKLIST_DOWNLOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PICKLIST_DOWNLOAD_SUCCESS:
      return {
        loading: false,
        consumptionReport: action.payload,
        error: "",
      };
    case GET_PICKLIST_DOWNLOAD_FAILURE:
      return {
        loading: false,
        consumptionReport: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export { getPicklistTrackingReportReducer, downloadPicklistTrackingReportReducer };
